// 乱数（mulberry32）。状態は数値1つなので保存・再生・サーバー検証で同じ列を再現できる。
export interface RngHolder {
  rng: number;
}

export function nextU32(h: RngHolder): number {
  let t = (h.rng = (h.rng + 0x6d2b79f5) >>> 0);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return (t ^ (t >>> 14)) >>> 0;
}

export const random = (h: RngHolder) => nextU32(h) / 4294967296;
export const randInt = (h: RngHolder, n: number) => Math.floor(random(h) * n);
export const chance = (h: RngHolder, p: number) => random(h) < p;
export const pick = <T>(h: RngHolder, list: readonly T[]): T => list[randInt(h, list.length)];

export function shuffle<T>(h: RngHolder, list: readonly T[]): T[] {
  const a = list.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = randInt(h, i + 1);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/** 重み付き抽選。weights の合計が0なら先頭を返す。 */
export function weighted<T>(h: RngHolder, items: readonly { item: T; weight: number }[]): T {
  const total = items.reduce((s, x) => s + x.weight, 0);
  let r = random(h) * total;
  for (const x of items) {
    if ((r -= x.weight) < 0) return x.item;
  }
  return items[0].item;
}

export const rngFrom = (seed: number): RngHolder => ({ rng: seed >>> 0 });

/** 文字列から32bitの種を作る（日付シードなど）。 */
export function seedOf(text: string): number {
  let h = 2166136261;
  for (let i = 0; i < text.length; i++) h = Math.imul(h ^ text.charCodeAt(i), 16777619);
  return h >>> 0;
}
